// Generated by CoffeeScript 2.3.2

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography'
;
var ImportDialog,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

ImportDialog = class ImportDialog extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.state = {
      imported: ""
    };
    return;
  }

  close() {
    this.setState({
      imported: ""
    });
    this.props.onClose();
  }

  handleClose() {
    boundMethodCheck(this, ImportDialog);
    this.close();
  }

  handleChange(event) {
    boundMethodCheck(this, ImportDialog);
    this.setState({
      imported: event.target.value
    });
  }

  handleCancel() {
    boundMethodCheck(this, ImportDialog);
    this.close();
  }

  handleDone() {
    boundMethodCheck(this, ImportDialog);
    this.props.app.importLog(this.state.imported);
    this.close();
  }

  render() {
    var open;
    ({open} = this.props);
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={this.handleClose}>
      <DialogTitle id="form-dialog-title"> Import </DialogTitle>
      <DialogContent>
      <Typography variant="h6"> Paste an exported log into the text field below: </Typography>
      <TextField autoFocus fullWidth={true} margin="normal" multiline={true} onChange={this.handleChange} placeholder="Paste here." value={this.state.imported} variant="outlined" />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.handleCancel}> Cancel </Button>
        <Button disabled={this.state.imported.length === 0} variant="contained" color="primary" onClick={this.handleDone}>
          Done
        </Button>
      </DialogActions>
    </Dialog>;
  }

};

export default ImportDialog;
